/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingQueryProductName extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSecurityHubFindingQueryProductName");
    }

    getFixupPrototypeFunction() { return AwsSecurityHubFindingQueryProductName.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingQueryProductName>): AwsSecurityHubFindingQueryProductName {
        let obj = Object.assign(new AwsSecurityHubFindingQueryProductName(), model);
        AwsSecurityHubFindingQueryProductName.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingQueryProductName>): AwsSecurityHubFindingQueryProductName {
        if (!model) return null;
        return AwsSecurityHubFindingQueryProductName.newInstance(<AwsSecurityHubFindingQueryProductName> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingQueryProductName) {
        if (!obj) return;

        models.AwsSecurityHubFindingQueryProductName.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingQueryProductName): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSecurityHubFindingQueryProductName.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Product names for the findings
     */
    product_names: Array<string>;

}
